import { useSelector } from 'react-redux';
import { trialOnboardDatalistItem } from 'reactApp/appHelpers/featuresHelpers/features/trialOnboarding';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useShowTrialOnboardDatalistItem = (): boolean => {
    const trialSubscription = useSelector(BillingDataSelectors.getTrialSubscription);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);

    const isActiveTrial = trialSubscription && trialSubscription.expires > Date.now();

    return trialOnboardDatalistItem && !!isActiveTrial && !isBizUser && !isCorpUser;
};
